import {pxToRem} from '../../../../utills/pxToRem'

export const contactUsStyles = {
    mt: pxToRem(15)
}
